import { AspectRatio, Grid } from '@mui/joy'
import Image from 'next/image'
import { Flex } from '../../Flex'
import { Text } from '../../Text'

export default function LoanBlock({
    src,
    alt,
    title,
    description,
    reversed = false,
}) {
    const first = (
        <Grid sm={12} md={6}>
            <AspectRatio ratio="1/1">
                <Image
                    quality={80}
                    fill
                    src={src}
                    alt={alt}
                    style={{
                        objectFit: 'cover',
                        borderRadius: '0% 45% 0% 0%',
                    }}
                />
            </AspectRatio>
        </Grid>
    )

    const second = (
        <Grid sm={12} md={6} px={12}>
            <Flex flexDirection="column" justify="center" h="100%">
                <Text fontSize="1.75rem" fontWeight={700} color="#0d417d">
                    {title}
                </Text>
                <Text
                    mt="15px"
                    fontSize="1rem"
                    pb={8}
                    fontWeight={300}
                    sx={{
                        whiteSpace: 'pre-wrap',
                    }}
                >
                    {description}
                </Text>
            </Flex>
        </Grid>
    )

    return (
        <Grid
            container
            spacing="30px"
            style={{
                alignItems: 'center',
            }}
        >
            {reversed ? [second, first] : [first, second]}
        </Grid>
    )
}
